import { useState } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { NavLink as RouterLink, matchPath, useLocation } from 'react-router-dom';
// material
import { styled } from '@mui/material/styles';
import { Box, List, Collapse, ListItemText, ListItemIcon, ListItemButton, Button } from '@mui/material';
//
import Iconify from './Iconify';

// ----------------------------------------------------------------------

const ListItemStyle = styled((props) => <ListItemButton disableGutters {...props} />)(({ theme }) => ({
  ...theme.typography.body2,
  height: 48,
  position: 'relative',
  textTransform: 'capitalize',
  color: '#F5F5F5',
  fontWeight: 'Regular',
  ':hover': {
    backgroundColor: 'rgba(0,0,0,0.2)',
    borderRadius: '10px',
  },
}));

const ListItemIconStyle = styled(ListItemIcon)({
  width: 22,
  height: 22,
  color: 'inherit',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
});

// ----------------------------------------------------------------------

NavItem.propTypes = {
  item: PropTypes.object,
  active: PropTypes.func,
};

function NavItem({ item, active }) {
  const isActiveRoot = active(item.path);

  const { title, path, icon, info, children } = item;
  // console.log('path', path);

  const [open, setOpen] = useState(isActiveRoot);

  const handleOpen = () => {
    setOpen((prev) => !prev);
  };

  const activeRootStyle = {
    color: 'white',
    fontWeight: '600',
    bgcolor: 'rgba(0,0,0,0.3)',
    borderRadius: '10px',
  };

  const activeSubStyle = {
    color: 'white',
    // fontWeight: '600',
    bgcolor: 'rgba(0,0,0,0.2)',
    borderRadius: '10px',
    // color: 'green',
    fontWeight: 'fontWeightMedium',
  };

  if (children) {
    return (
      <>
        <ListItemStyle
          onClick={handleOpen}
          sx={{
            ...(isActiveRoot && activeRootStyle),
            mt: 0.3,
            mb: 0.3,
          }}
        >
          <ListItemIconStyle>{icon && icon}</ListItemIconStyle>
          <ListItemText disableTypography primary={title} />
          {info && info}
          <Iconify icon={'material-symbols:arrow-drop-down-circle'} sx={{ width: 16, height: 16, mr: 1 }} />
        </ListItemStyle>

        <Collapse in={open} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            {children.map((item) => {
              const { title, path } = item;
              const isActiveSub = active(path);

              return (
                <ListItemStyle
                  key={title}
                  component={RouterLink}
                  to={path}
                  sx={{
                    ...(isActiveSub && activeSubStyle),
                    mt: 0.3,
                    mb: 0.3,
                  }}
                  onClick={() => {
                    if (path === '/dashboard/recruitment/master') {
                      localStorage.setItem('tabValue', '1');
                    }
                    if (path === '/dashboard/matrimony/master') {
                      localStorage.setItem('tabValueMtrimony', '1');
                    }
                  }}
                >
                  <ListItemIconStyle>
                    <Box
                      component="span"
                      sx={{
                        width: 4,
                        height: 4,
                        display: 'flex',
                        borderRadius: '50%',
                        alignItems: 'center',
                        justifyContent: 'center',
                        bgcolor: 'text.disabled',
                        transition: (theme) => theme.transitions.create('transform'),
                        ...(isActiveSub && {
                          transform: 'scale(2)',
                          bgcolor: 'white',
                        }),
                      }}
                    />
                  </ListItemIconStyle>
                  <ListItemText disableTypography primary={title} />
                </ListItemStyle>
              );
            })}
          </List>
        </Collapse>
      </>
    );
  }

  return (
    <ListItemStyle
      component={RouterLink}
      to={path}
      sx={{
        ...(isActiveRoot && activeRootStyle),
        mt: '3px',
      }}
      onClick={() => {
        if (path === '/dashboard/transactions') {
          localStorage.setItem('tabValueTrans', '1');
        }
      }}
    >
      <ListItemIconStyle>{icon && icon}</ListItemIconStyle>
      <ListItemText disableTypography primary={title} />
      {info && info}
    </ListItemStyle>
  );
}

NavSection.propTypes = {
  navConfig: PropTypes.array,
};

export default function NavSection({ navConfig, ...other }) {
  const { pathname } = useLocation();

  const match = (path) => (path ? !!matchPath({ path, end: false }, pathname) : false);
  // const { loggedInRole } = useSelector((state) => ({
  //   loggedInRole: state.authentication.user?.data?.data[0].role,
  // }));

  const loggedInRole = localStorage.getItem('role');

  return (
    <Box {...other}>
      <List disablePadding sx={{ p: 1 }}>
        {navConfig?.map((item) =>
          item.isReviewer === false && loggedInRole === 'Reviewer' ? null : (
            <NavItem key={item.title} item={item} active={match} />
          )
        )}
      </List>
    </Box>
  );
}
